import React, { useState } from "react";
import { Link } from "react-router-dom";
import CategoryDropdown from "./CategoryDropdown";

function Footer({ cart }) {
  const [activeAccordion, setActiveAccordion] = useState(null);
  const toggleAccordion = (index) => {
    setActiveAccordion(activeAccordion === index ? null : index);
  };

  return (
    <footer className="bg-gray-900 text-gray-200 py-10">
      <div className="container mx-auto grid grid-cols-1 gap-8 md:grid-cols-3">
        {/* Column 1: Branding & Newsletter */}
        <div className="space-y-4">
          <div className="flex items-center gap-2">
            <span className="text-2xl font-extrabold">Spores Bro</span>
          </div>
          <p className="text-sm">
            Cultivating Quality, Inspiring Growth.
          </p>
          <address className="not-italic text-sm">
            New York, USA <br />
            <a href="mailto:info@sporesbro.com" className="text-blue-400 hover:underline">
              info@sporesbro.com
            </a>
          </address>
          <form className="mt-4">
            <label htmlFor="newsletter" className="block text-sm font-medium">
              Subscribe to our Newsletter
            </label>
            <div className="mt-2 flex">
              <input
                type="email"
                id="newsletter"
                placeholder="your.email@example.com"
                className="w-full rounded-l-md border-gray-300 p-2 focus:outline-none focus:ring-2 focus:ring-blue-500"
              />
              <button
                type="submit"
                className="rounded-r-md bg-blue-600 px-4 py-2 text-white font-semibold hover:bg-blue-700 focus:outline-none focus:ring-2 focus:ring-blue-500"
              >
                Subscribe
              </button>
            </div>
          </form>
        </div>

        {/* Column 2: Navigation Links */}
        <div className="grid grid-cols-2 gap-4">
          <div>
            <h6 className="mb-2 text-lg font-semibold">Company</h6>
            <ul className="space-y-2 text-sm">
              <li>
                <Link to="/" className="hover:underline">
                  Home
                </Link>
              </li>
              <li>
                <Link to="/about-us" className="hover:underline">
                  About Us
                </Link>
              </li>
              <li>
                <Link to="/contact-us" className="hover:underline">
                  Contact
                </Link>
              </li>
            </ul>
          </div>
          <div>
            <h6 className="mb-2 text-lg font-semibold">Shop</h6>
            <ul className="space-y-2 text-sm">
              <li>
                <Link to="/shop" className="hover:underline">
                  Shop
                </Link>
              </li>
              <li>
                <CategoryDropdown />
              </li>
              <li>
                <Link to="/cart" className="hover:underline">
                  Cart ({cart.length})
                </Link>
              </li>
              <li>
                <Link to="/checkout" className="hover:underline">
                  Checkout
                </Link>
              </li>
              <li>
                <Link to="/track_order" className="hover:underline">
                  Track Order
                </Link>
              </li>
            </ul>
          </div>
        </div>

        {/* Column 3: Legal & FAQ Accordion */}
        <div>
          <h6 className="mb-2 text-lg font-semibold">Disclaimer</h6>
          <p className="text-sm leading-relaxed">
            All magic mushroom spores sold on this website are intended for research purposes only. We do not endorse or promote any illegal use of our products.
          </p>
          <div className="mt-4">
            <h6 className="mb-2 text-lg font-semibold">FAQ</h6>
            {[
              {
                question: "What are magic mushroom spores?",
                answer:
                  "They are the reproductive cells of Psilocybe mushrooms. They contain the genetic material but not the psychoactive compounds until grown.",
              },
              {
                question: "What substrates work best for cultivation?",
                answer:
                  "Common substrates include straw, sawdust, coffee grounds, and compost, depending on the mushroom species.",
              },
              {
                question: "How long does cultivation take?",
                answer:
                  "Depending on the species and conditions, mushrooms can mature in days to weeks after full colonization.",
              },
              {
                question: "Is it legal to buy spores online?",
                answer:
                  "In most states, purchasing spores for research purposes is legal; however, restrictions apply in certain regions.",
              },
            ].map((faq, index) => (
              <div key={index} className="border-t border-gray-700 pt-2">
                <button
                  onClick={() => toggleAccordion(index)}
                  className="w-full text-left text-sm font-medium focus:outline-none hover:underline"
                >
                  {faq.question} <span>{activeAccordion === index ? "-" : "+"}</span>
                </button>
                {activeAccordion === index && (
                  <p className="mt-1 text-xs text-gray-400">{faq.answer}</p>
                )}
              </div>
            ))}
          </div>
          <p className="mt-6 text-xs">
            &copy; {new Date().getFullYear()} Spores Bro. All rights reserved.
          </p>
        </div>
      </div>
    </footer>
  );
}

export default Footer;
